import {post} from '@/utils/request'

export function getNavList() {
  return post('admin/department/list')
}
export function getOptionTask() {
  return post('task/task/choice')
}